import classnames from 'classnames';
import textClassSwitcher from '../../utils/textClassSwitcher';
import * as styles from '../Testimonials.css';
import type { TTestimonialAttributes } from '../Testimonials.types';

interface Props {
  message: string;
  className?: string;
  attributes?: TTestimonialAttributes;
}

const Message = ({ message, className = '', attributes }: Props) => {
  return (
    <blockquote
      className={classnames(
        styles.testimonialsMessage,
        textClassSwitcher(className, attributes?.messageFontSize || 'text-sm'),
      )}
    >{`"${message}"`}</blockquote>
  );
};

export default Message;
